import StartupsFundraisesInstance from 'modules/startupsFundraises/repository';

export const getStartupFundraises = (startup, options) => {
  return StartupsFundraisesInstance.getStartupFundraises(startup, options);
};

export const deleteStartupFundraise = (startup, fundraise) => {
  return StartupsFundraisesInstance.deleteStartupFundraise(startup, fundraise);
};
